import en from './en.mjs'

export default Object.freeze({
  ...en,
  'common.language.label': '言語',
  'common.download.action': 'ダウンロード',
  'common.store.appleprefix': 'App Storeから',
  'common.store.googleprefix': 'Google Playで',
  'seo.home.title': 'Happy Pets｜AIパートナー・自己分析テスト・ペットウィジェット',
  'seo.home.description': '日々の振り返り、性格テスト、タロット、夢のヒント、ウィジェット、友だちとの共同育成を楽しめるAIペットです。',
  'seo.home.keywords': 'Happy Pets, AIパートナー, バーチャルペット, ウィジェット, 性格診断, MBTI, AIタロット',
  'seo.invite.title': 'Happy Petsの招待｜友だちとペットを育てよう',
  'seo.invite.description': 'Happy Petsの招待を開き、iPhoneやAndroidで友だちとバーチャルペットを育てましょう。',
  'nav.skills.label': 'スキル',
  'nav.tests.label': 'テスト',
  'nav.guidance.label': 'AIガイド',
  'nav.features.label': '機能',
  'nav.experience.label': '体験',
  'nav.community.label': 'コミュニティ',
  'nav.news.label': 'ニュース',
  'home.hero.titlelead': '小さなペットが、',
  'home.hero.titleaccent': '毎日を少しお手伝い',
  'home.hero.subtitle': '画面の中で暮らす、やさしいバーチャルペットを迎えましょう。一緒に成長し、日常を助ける便利なスキルや楽しい時間を届けます。',
  'home.tools.eyebrow': 'ペットスキル',
  'home.tools.title': 'ペットが手伝ってくれる毎日のこと',
  'home.tools.description': '振り返り、献立のアイデア、性格の理解、小さな意思決定まで、ペットが便利なパートナーになります。',
  'home.tools.action': '今すぐ試す',
  'tool.tarot.tag': '振り返り',
  'tool.tarot.title': 'タロット',
  'tool.tarot.description': 'ペットにカードを引いてもらい、今の悩みを別の角度からやさしく見つめます。',
  'tool.mbti.tag': '性格',
  'tool.mbti.title': 'MBTI',
  'tool.mbti.description': 'タイプや傾向を比べながら、自分の考え方や人とのつながり方を探ります。',
  'tool.chef.tag': 'キッチン',
  'tool.chef.title': '冷蔵庫シェフ',
  'tool.chef.description': '冷蔵庫にある食材を、賢い小さなシェフと一緒に簡単な料理へ変えましょう。',
  'tool.fortune.tag': '毎日',
  'tool.fortune.title': '今日の運勢',
  'tool.fortune.description': '気分や運、小さな出来事への軽やかなヒントで一日を始めます。',
  'tool.calorie.tag': '健康',
  'tool.calorie.title': 'カロリー計算',
  'tool.calorie.description': 'カロリーの目安や栄養の傾向を知り、食事を選びやすくします。',
  'tool.dream.tag': '夢',
  'tool.dream.title': '夢占い',
  'tool.dream.description': '昨夜の夢のシンボルを整理し、ぼんやりした断片を振り返りのテーマに変えます。',
  'home.assessments.eyebrow': '自分をもっと知る',
  'home.assessments.title': '結果をさらに探れる自己発見テスト',
  'home.assessments.description': '性格、推理、仕事、関係性のテストを受け、結果をAIパートナーとの会話でさらに深めましょう。',
  'home.assessments.action': 'テストを始める',
  'home.assessments.disclaimer': 'これらのテストは自己理解と娯楽のためのものです。医療診断や専門家の助言に代わるものではありません。',
  'assessment.mbti.eyebrow': '性格',
  'assessment.mbti.title': 'MBTI性格テスト',
  'assessment.mbti.description': '好み、コミュニケーション、強み、成長パターンを詳しく探ります。',
  'assessment.mbti.meta': '108問',
  'assessment.sbti.eyebrow': '交流スタイル',
  'assessment.sbti.title': 'SBTI性格テスト',
  'assessment.sbti.description': '感情、行動、社会的エネルギーなど5つの楽しい視点から、人との関わり方を見つけます。',
  'assessment.sbti.meta': '62問',
  'assessment.iq.eyebrow': '推理',
  'assessment.iq.title': 'IQ推理テスト',
  'assessment.iq.description': '非言語のパターン問題に取り組み、さまざまな推理領域を比べます。',
  'assessment.iq.meta': '視覚的推理',
  'assessment.holland.eyebrow': 'キャリア',
  'assessment.holland.title': 'ホランド職業興味',
  'assessment.holland.description': '6つの興味領域から、自分に自然に合いそうな活動や仕事環境を見つけます。',
  'assessment.holland.meta': '職業興味',
  'assessment.attachment.eyebrow': '人間関係',
  'assessment.attachment.title': '愛着スタイルテスト',
  'assessment.attachment.description': '親密さ、信頼、安心感、自立について振り返り、関係のパターンを理解します。',
  'assessment.attachment.meta': '関係性のヒント',
  'home.guidance.eyebrow': 'やさしい毎日の習慣',
  'home.guidance.title': '振り返りを大切にするAI神秘ガイド',
  'home.guidance.description': 'タロット、今日の運勢、夢のシンボルを通して立ち止まり、気持ちに名前をつけ、次の小さな一歩を見つけます。未来の断定ではなく、今日の明晰さと安心が目的です。',
  'guidance.tarot.title': 'AIタロット',
  'guidance.tarot.description': '問いに合わせてカードを選び、振り返りや視点の変化、次の一歩へのやさしいヒントにします。',
  'guidance.tarot.note': '振り返りと娯楽のために',
  'guidance.fortune.title': '今日の運勢',
  'guidance.fortune.description': '気分、エネルギー、幸運のポイント、実用的な励ましとともに一日を始めます。',
  'guidance.fortune.note': '毎日新しいガイド',
  'guidance.dream.title': '夢占い',
  'guidance.dream.description': '夢の映像や感情を、決まった予言ではなく探求できるテーマに変えます。',
  'guidance.dream.note': 'シンボル、感情、振り返り',
  'home.features.eyebrow': '役立つスキル、毎日の喜び',
  'home.features.title': 'ペットがどんどん頼れる存在になる理由',
  'feature.raise.title': 'かわいいペットを育てる',
  'feature.raise.description': 'ごはんをあげ、遊びながら、かわいくて心強い便利なパートナーへ育てます。',
  'feature.hatch.title': '新しいスキルを孵化',
  'feature.hatch.description': '卵を集め、異なる性格と便利なスキルを持つユニークなペットに出会えます。',
  'feature.coraising.title': '親友と一緒に育てる',
  'feature.coraising.description': '友だちを招待して一緒にお世話。愛情も楽しさも2倍です。',
  'feature.status.title': '毎日の状態',
  'feature.status.description': 'その日の状態を記録し、気持ちをペットに話しましょう。',
  'feature.frequency.title': '毎日の頻度',
  'feature.frequency.description': '水分補給やランニングなど、自分のイベントと頻度を記録します。',
  'feature.cleaner.title': '写真クリーナー',
  'feature.cleaner.description': '遊びながら写真を整理。楽しく効率的です。',
  'feature.skills.title': 'AIスキルルーム',
  'feature.skills.description': '新しい見た目を解放し、振り返りや計画、日常を助ける方法をさらに発見します。',
  'feature.widget.title': 'インタラクティブウィジェット',
  'feature.widget.description': 'ホーム画面のウィジェットで、いつでもペットをそばに置けます。',
  'home.steps.eyebrow': 'はじめ方',
  'home.steps.title': '役立つスキルを持つペットを孵化しよう',
  'step.adopt.title': '迎える',
  'step.adopt.description': '自分だけの卵を選び、ペットとの旅を始めます。',
  'step.grow.title': '育てる',
  'step.grow.description': '毎日ごはんをあげて遊び、交流しながら、新しいスキルを学べるよう育てます。',
  'step.together.title': '一緒に',
  'step.together.description': '友だちを招待し、個性と支え合いに満ちた世界をペットたちと共有します。',
  'home.reviews.eyebrow': 'コミュニティ',
  'home.reviews.title': 'かわいいだけじゃないから愛される',
  'home.reviews.role': 'ペットの家族',
  'home.news.eyebrow': 'ニュースとストーリー',
  'home.news.title': '最新ニュース',
  'home.news.description': 'ペットとの暮らし、自分らしさの発見、毎日のウェルビーイングにつながる優しいヒントをお届けします。',
  'home.news.readarticle': '記事を読む',
  'home.news.exploreall': 'ニュースをすべて見る',
  'review.one.text': 'ペットはとてもかわいいですが、日々の小さなスキルをこんなに使うとは思いませんでした。',
  'review.two.text': '恋人と一緒に育てるのが楽しく、追加スキルも毎日役立っています。',
  'review.three.text': 'ウィジェットがとてもインタラクティブ。ホーム画面のかわいい相棒が日常も手伝ってくれます。',
  'home.footer.tagline': 'ホーム画面に喜びと寄り添いを。',
  'home.footer.product': '製品',
  'home.footer.support': 'サポート',
  'home.footer.social': 'ソーシャル',
  'home.footer.skills': 'ペットスキル',
  'home.footer.features': '機能',
  'home.footer.widgets': 'ウィジェット',
  'home.footer.help': 'ヘルプセンター',
  'home.footer.privacy': 'プライバシー',
  'home.footer.terms': '利用規約',
  'home.footer.copyright': '© 2024 Happy Pet. All rights reserved.',
  'home.image.logoalt': 'Happy Petsロゴ',
  'home.image.screenalt': 'Happy Petsアプリ画面',
  'home.image.enlargedalt': '拡大したHappy Pets画面',
  'home.image.close': '画像を閉じる',
  'invite.headline': '友だちが一緒にペットを育てようと招待しています！',
  'invite.description': '招待を受けると卵がすぐに孵化します。ペットをホーム画面にも追加できます。',
  'invite.download': 'ダウンロード',
  'invite.loadingalt': 'Happy Petsを読み込み中',
  'invite.screensalt': 'Happy Petsアプリのスクリーンショット'
})
